export const FILTER_BLOGS_LOADER = "FILTER_BLOGS_LOADER";
export const FILTER_BLOGS_SUCCESS = "FILTER_BLOGS_SUCCESS";
export const FILTER_BLOGS_FAILURE = "FILTER_BLOGS_FAILURE";
export const FILTER_BLOGS_RESET = "FILTER_BLOGS_RESET";